import styled from 'styled-components';
import sizes from '../../../util/sizes';
import Typography from '../Typography';

const defaultCheckMark = '/icons/checkmark.svg';

interface CheckMarkItemProps {
  iconUrl?: string;
}

const CheckMarkItem = styled(Typography)<CheckMarkItemProps>`
  display: flex;
  align-items: start;
  max-width: ${sizes.XL};

  :not(:first-of-type) {
    margin-top: 24px;
    max-width: ${sizes.XL};
  }

  &:before {
    content: '';
    display: inline-block;
    min-width: 24px;
    min-height: 24px;
    background: ${(props) => `url(${props.iconUrl || defaultCheckMark}) no-repeat;`};
    margin-right: 16px;
    background-size: contain;
  }
`;

export default CheckMarkItem;
